// @flow @jsx h

import { h } from 'preact'
import { Result } from '../../../../../components/Result/Result'
import { getSelectedAlternativeId } from '../../../helpers/cookieUtils'
import type { Poll, Result as ResultType } from '../../../../../types'
import { bem } from '../../../../../helpers/bem'
import { themeToClassName } from '../../../../../helpers/themeToClassName'

import styles from './LiveResult.css'

type Props = {
  result: ResultType,
  resultError?: Error,
  poll: Poll,
  showResult?: boolean,
  resultMessage?: string
}

type Context = {
  theme: string
}

const LiveResult = (props: Props, { theme }: Context) => {
  const {
    poll,
    result,
    resultError,
    showResult = true,
    resultMessage = 'Takk for din stemme'
  } = props

  if (showResult) {
    return (
      <Result
        highlightedResultItemId={getHighlightedResultItemId(poll.id)}
        result={result}
        error={resultError}
        clickable
      />
    )
  }

  if (!resultMessage) {
    return null
  }

  return (
    <div class={bem(styles['live-result'], themeToClassName(theme))}>
      <p class={styles['live-result__paragraph']}>
        {resultMessage}
        <svg
          aria-hidden
          xmlns='http://www.w3.org/2000/svg'
          width='14'
          height='14'
          viewBox='0 0 14 14'
          class={styles['live-result__check']}
        >
          <path
            fill='none'
            stroke='#00B2F7'
            stroke-linecap='round'
            stroke-linejoin='round'
            stroke-width='2'
            d='M1 6.63L4.77 11 13 1'
          />
        </svg>
      </p>
    </div>
  )
}

function getHighlightedResultItemId (pollId: number): ?number {
  return getSelectedAlternativeId(pollId)
}

export { LiveResult }



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/LiveResult/LiveResult.js